import styled, { css } from "styled-components";

import BaseButton from "shared/components/inputs/button/BaseButton";
import { COLOR_VALUES } from "shared/config/colors";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";

export const StyledLink = styled(BaseButton)`
    ${(props) =>
        props.variant
            ? css`
                  ${props.variant};
              `
            : css`
                  ${TEXT_VARIANT_STYLES.Body_2_2};
              `}

    ${(props) =>
        props.color
            ? css`
                  color: ${COLOR_VALUES[props.color]};
              `
            : css`
                  color: ${COLOR_VALUES.Gray_4};
              `}


    &:hover {
        color: ${COLOR_VALUES.Gray_2};
    }

    &:active {
        color: ${COLOR_VALUES.Black};
    }

    &:disabled {
        color: ${COLOR_VALUES.Gray_4};
    }
`;
